import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Area } from '../interfaces/area';

@Injectable({
  providedIn: 'root'
})
export class AreaService {
  private myAppUrl: string;
  private myApiUrl: string;

  constructor(private http: HttpClient) {
    this.myAppUrl = environment.endpoint;
    this.myApiUrl = 'api/areas/'
  }
  getListAreas(): Observable<Area[]> {

      return this.http.get<Area[]>(`${this.myAppUrl}${this.myApiUrl}`);
     }
   
     deleteArea(id: number): Observable<void> {
       return this.http.delete<void>(`${this.myAppUrl}${this.myApiUrl}${id}`)
     }
   
     saveArea(area: Area): Observable<void> {
       return this.http.post<void>(`${this.myAppUrl}${this.myApiUrl}`,area)
     }
   
     getArea(id: number): Observable<Area> {
       return this.http.get<Area>(`${this.myAppUrl}${this.myApiUrl}${id}`)
     }
   
     updateArea(id: number, area: Area): Observable<void> {
       return this.http.put<void>(`${this.myAppUrl}${this.myApiUrl}${id}`, area);
     }
   }